export { default } from './ComponentWrap'
